/**
 * feature/catalogue — spec §F8 (Data Catalogue).
 * PLACEHOLDER: this feature ships in milestone M5 (§K). M1 Task 7 creates the folder per
 * the §B5 tree and a component that renders the milestone marker, so every route in §F1
 * resolves and the topbar nav is exercised end to end from M1. Strings go through
 * `t()` per §F12 (keys under `placeholder.`).
 */
import { useTranslation } from 'react-i18next';

import { Placeholder } from '../../components/Placeholder';

export function CataloguePage() {
  const { t } = useTranslation();
  return (
    <Placeholder
      title={t('placeholder.catalogue')}
      body={t('placeholder.catalogueBody')}
      milestone="M5"
    />
  );
}

export default CataloguePage;
